import React from 'react';
import logo from './assets/logo.svg';

export function Home() {
  return (
    <div className="hero">
      <div className="hero-content">
        <img 
          src={logo} 
          alt="GS PC Parts and Builds Logo" 

        />
      </div>
    </div>
  );
}
